import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import CalculadoraComercialPayefy from './CalculadoraComercialPayefy';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CalculadoraComercialPayefy />
  </React.StrictMode>
);

